export const supportedMegaPrograms = [
  ["AA", "American Airlines AAdvantage"],
  ["AC", "Air Canada Aeroplan"],
  ["AM", "Aeromexico Club Premier"],
  ["AS", "Alaska Airlines Mileage Plan"],
  ["AV", "Avianca LifeMiles"],
  ["B6", "JetBlue True Blue"],
  // ["BA", "British Airways Executive Club"],
  ["CM", "Copa ConnectMiles"],
  ["G3", "GOL Smiles"],
  ["DL", "Delta SkyMiles"],
  ["EK", "Emirates Skywards"],
  ["EY", "Etihad Guest"],
  // ["F9", "Frontier"],
  ["IB", "Iberia Avios"],
  ["KL", "Air France/KLM Flying Blue"],
  ["NK", "Spirit"],
  ["QF", "Qantas Frequent Flyer"],
  ["SK", "SAS EuroBonus"],
  ["TP", "TAP Air Portugal Miles&Go"],
  ["TK", "Turkish Miles & Smiles"],
  ["UA", "United MileagePlus"],
  ["VA", "Virgin Australia Velocity"],
  ["VS", "Virgin Atlantic Flying Club"],
];

export const supportedPrograms = supportedMegaPrograms.map((value) => {
  return {
    value: value[0],
    name: value[0],
    fullname: value[1],
  };
});

// Sort by name
export const megaProgramsOptions = supportedPrograms.sort((a, b) => {
  return a.name.localeCompare(b.name);
});
